/**
 * @author        jose.lucena@zumper.com (José Lucena)
 * @copyright     Copyright (c) 2025, Zumper
 * @description   Metro rent report
 */

import { Bizo, autoclass } from './base'
import type {
  MetroRentReportCity as MetroRentReportCityTypes,
  MetroRentReport as MetroRentReportTypes,
  RawMetroRentReport,
} from './metroRentReport.types'

export const MetroRentReport: typeof MetroRentReportTypes = autoclass<
  MetroRentReportTypes,
  RawMetroRentReport
>(
  'MetroRentReport',
  class MetroRentReport extends Bizo<MetroRentReportTypes, RawMetroRentReport> {},
  {
    metroRentReportId: 'metro_rent_report_id',
    createdOn: 'created_on',
    modifiedOn: 'modified_on',
    url: 'url',
    intro: 'intro',
    imageOneUrl: 'image_one_url',
    imageTwoUrl: 'image_two_url',
    imageThreeUrl: 'image_three_url',
    mostExpensiveFirst: 'most_expensive_first',
    mostExpensiveFirstCity: 'most_expensive_first_city',
    mostExpensiveFirstTiedCity: 'most_expensive_first_tied_city',
    mostExpensiveFirstTertiaryTiedCity: 'most_expensive_first_tertiary_tied_city',
    mostExpensiveSecond: 'most_expensive_second',
    mostExpensiveSecondCity: 'most_expensive_second_city',
    mostExpensiveSecondTiedCity: 'most_expensive_second_tied_city',
    mostExpensiveSecondTertiaryTiedCity: 'most_expensive_second_tertiary_tied_city',
    mostExpensiveThird: 'most_expensive_third',
    mostExpensiveThirdCity: 'most_expensive_third_city',
    mostExpensiveThirdTiedCity: 'most_expensive_third_tied_city',
    mostExpensiveThirdTertiaryTiedCity: 'most_expensive_third_tertiary_tied_city',
    leastExpensiveFirst: 'least_expensive_first',
    leastExpensiveFirstCity: 'least_expensive_first_city',
    leastExpensiveFirstTiedCity: 'least_expensive_first_tied_city',
    leastExpensiveFirstTertiaryTiedCity: 'least_expensive_first_tertiary_tied_city',
    leastExpensiveSecond: 'least_expensive_second',
    leastExpensiveSecondCity: 'least_expensive_second_city',
    leastExpensiveSecondTiedCity: 'least_expensive_second_tied_city',
    leastExpensiveSecondTertiaryTiedCity: 'least_expensive_second_tertiary_tied_city',
    leastExpensiveThird: 'least_expensive_third',
    leastExpensiveThirdCity: 'least_expensive_third_city',
    leastExpensiveThirdTiedCity: 'least_expensive_third_tied_city',
    leastExpensiveThirdTertiaryTiedCity: 'least_expensive_third_tertiary_tied_city',
    fastestGrowingYoyFirst: 'fastest_growing_yoy_first',
    fastestGrowingYoyFirstCity: 'fastest_growing_yoy_first_city',
    fastestGrowingYoyFirstTiedCity: 'fastest_growing_yoy_first_tied_city',
    fastestGrowingYoyFirstTertiaryTiedCity: 'fastest_growing_yoy_first_tertiary_tied_city',
    fastestGrowingYoySecond: 'fastest_growing_yoy_second',
    fastestGrowingYoySecondCity: 'fastest_growing_yoy_second_city',
    fastestGrowingYoySecondTiedCity: 'fastest_growing_yoy_second_tied_city',
    fastestGrowingYoySecondTertiaryTiedCity: 'fastest_growing_yoy_second_tertiary_tied_city',
    fastestGrowingYoyThird: 'fastest_growing_yoy_third',
    fastestGrowingYoyThirdCity: 'fastest_growing_yoy_third_city',
    fastestGrowingYoyThirdTiedCity: 'fastest_growing_yoy_third_tied_city',
    fastestGrowingYoyThirdTertiaryTiedCity: 'fastest_growing_yoy_third_tertiary_tied_city',
    fastestGrowingMomFirst: 'fastest_growing_mom_first',
    fastestGrowingMomFirstCity: 'fastest_growing_mom_first_city',
    fastestGrowingMomFirstTiedCity: 'fastest_growing_mom_first_tied_city',
    fastestGrowingMomFirstTertiaryTiedCity: 'fastest_growing_mom_first_tertiary_tied_city',
    fastestGrowingMomSecond: 'fastest_growing_mom_second',
    fastestGrowingMomSecondCity: 'fastest_growing_mom_second_city',
    fastestGrowingMomSecondTiedCity: 'fastest_growing_mom_second_tied_city',
    fastestGrowingMomSecondTertiaryTiedCity: 'fastest_growing_mom_second_tertiary_tied_city',
    fastestGrowingMomThird: 'fastest_growing_mom_third',
    fastestGrowingMomThirdCity: 'fastest_growing_mom_third_city',
    fastestGrowingMomThirdTiedCity: 'fastest_growing_mom_third_tied_city',
    fastestGrowingMomThirdTertiaryTiedCity: 'fastest_growing_mom_third_tertiary_tied_city',
    hasMetroDeclined: 'has_metro_declined',
  }
)

export type MetroRentReport = MetroRentReportTypes
export type MetroRentReportCity = MetroRentReportCityTypes
